import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Modal } from 'antd';
import './messageTwoImage.css';
import PropTypes from 'prop-types';

import doneButtonImg from '../../public/img/newMessage/DoneButton.png'
import turnitin from '../../public/img/newMessage/turnitin.png'
/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let MessageTwoImage3 = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);

    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow,
        }
    });

    /**
     * 标题默认值处理
     */
    useEffect(() => {

    }, []);

    return (
        <Modal
            open={isShow}
            onCancel={null}
            closeIcon={null}
            footer={null}
            className='messageTwoImage'
            width={735}
            centered
            closable={false}
        >
            <img src={turnitin} className='rightImg3' />
            <div className='contentBox'>
                {content}
            </div>
            
                 <img src={doneButtonImg} className='doneButtonImg2' onClick={props.done} />
            

        </Modal>
    )

}

MessageTwoImage3 = forwardRef(MessageTwoImage3);

MessageTwoImage3.propTypes = {
    done: PropTypes.func.isRequired,
};

export default MessageTwoImage3;